<!-- 点击页面报名抽奖，填写报名信息 -->
<template>
  <div class="plv-ia-enroll-lottery-add-msg">
    <template v-if="enrollProcess === 'unenrolled'">
      <img src="../imgs/icon-winner.png" />
      <p class="plv-ia-enroll-lottery-add__content--prize">{{ iarTrans('enrollLottery.prize') }}：{{ prize }}</p>
      <p class="plv-ia-enroll-lottery-add__content--countdown">{{ iarTrans('enrollLottery.countdown') }} <span>{{ count }}</span></p>
      <ul class="plv-ia-enroll-lottery-submit__content">
        <li>
          <span>{{ iarTrans('enrollLottery.name') }}：</span>
          <div :class="['plv-ia-enroll-lottery-add-msg__input', { 'plv-ia-enroll-lottery-input__wrong': wrongName }]">
            <input
              v-model="name"
              type="text"
              :placeholder="iarTrans('enrollLottery.enterName')"
              maxlength="30"
              @focus="wrongName = false"
              @blur="nameInputBlur"
            />
            <span>{{ name.length }}/30</span>
          </div>
        </li>
        <li>
          <span>{{ iarTrans('enrollLottery.phone') }}：</span>
          <div>
            <input
              v-model="mobile"
              type="tel"
              :class="['plv-ia-enroll-lottery-add-msg__input', { 'plv-ia-enroll-lottery-input__wrong': wrongTel }]"
              :placeholder="iarTrans('enrollLottery.enterPhone')"
              @blur="checkPhone"
              @focus="wrongTel = false"
              @keyup="onlyNumber"
            />
            <p v-if="enrolled" class="plv-ia-enroll-lottery__error--tips"><span>!</span>{{ iarTrans('enrollLottery.beenRegistered') }}</p>
          </div>
        </li>
      </ul>
      <iar-button
        class="plv-ia-enroll-lottery-add-msg__button"
        :disabled="!submitEnabled"
        @click="submitMessage"
      >
        {{ iarTrans('enrollLottery.submit') }}
      </iar-button>
      <p class="plv-ia-enroll-lottery__tips">
        <IconTipIllustrate :size="14" color="#757575" style="margin-right: 4px;" />
        <span>{{ iarTrans('enrollLottery.ensureInfo') }}</span>
      </p>
    </template>
    <template v-else-if="enrollProcess === 'success'">
      <div class="plv-ia-enroll-lottery-add__success">
        <IconTipRight class="plv-iar-enroll-lottery-icon--success" :size="60" color="#44c18c" />
        <p>{{ iarTrans('enrollLottery.regSuccess') }}</p>
        <iar-button class="plv-ia-enroll-lottery-add-msg__button" @click="$emit('close-modal')">{{ iarTrans('enrollLottery.sure') }}</iar-button>
      </div>
    </template>
  </div>
</template>

<script>
import IarButton from '../../common/button/PcButton.vue';
import mixin from './mixin';
import IconTipRight from '../../../icon-components/icons/icon-tip-right';
import IconTipIllustrate from '../../../icon-components/icons/icon-tip-illustrate';
export default {
  components: {
    IarButton,
    IconTipRight,
    IconTipIllustrate
  },

  mixins: [mixin],
};

</script>

<style lang="scss">
.plv-ia-enroll-lottery-add-msg {
  padding: 32px 0 24px;
  text-align: center;
  font-size: 14px;

  >img {
    width: 60px;
    height: 60px;
    display: block;
    margin: 0 auto;
  }

  .plv-ia-enroll-lottery-add__content--prize {
    color: #333;
    margin: 16px auto 8px;
  }

  .plv-ia-enroll-lottery-add__content--countdown {
    color: #757575;
    >span {
      color: #2671FD;
      font-weight: bold;
    }
  }

  .plv-ia-enroll-lottery-add-msg__error--tips {
    height: 32px;
    line-height: 32px;
    background: #FB7272;
    color: #FFFFFF;
    font-size: 14px;
  }

  .plv-ia-enroll-lottery-submit__content {
    padding-top: 12px;
    >li {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      padding-right: 95px;

      >div {
        position: relative;
      }

      >span {
        line-height: 40px;
        text-align: right;
        color: #333;
      }

      input {
        outline: none;
        background: transparent;
      }

      .plv-ia-enroll-lottery-add-msg__input {
        width: 320px;
        height: 40px;
        padding: 0 8px;
        border-radius: 2px;
        border: 1px solid #CFD8DC;
        flex-shrink: 0;
        display: flex;
        align-items: center;

        >input {
          height: 100%;
          border: none;
          flex: 1;
        }
        span {
          width: 34px;
          font-size: 12px;
          color: #9E9E9E;
          text-align: right;
        }
      }

      .plv-ia-enroll-lottery-input__wrong {
        border: 1px solid #FF5722;
        background: #FFE9E9;
      }
    }
  }

  .plv-ia-enroll-lottery__tips {
    padding: 0 24px;
    font-size: 12px;
    color: #757575;
    display: flex;
    justify-content: center;
  }

  .plv-ia-enroll-lottery__error--tips {
    position: absolute;
    color: #FF5722;

    >span {
      width: 16px;
      height: 16px;
      display: inline-block;
      margin: 4px 4px 0 0;
      padding-top: 2px;
      background: #ff5722;
      color: #fff;
      font-size: 12px;
      border-radius: 8px;
      vertical-align: text-bottom;
      box-sizing: border-box;
    }
  }

  .plv-ia-enroll-lottery-add-msg__button {
    margin: 24px auto;
  }

  .plv-ia-enroll-lottery-add__success {
    .plv-iar-enroll-lottery-icon--success {
      margin: 70px auto 24px;
    }

    >p {
      color: #333;
    }

    button {
      background: #2196F3;
    }
  }
}

</style>
